import React from 'react';
import { LogOut } from 'lucide-react';

const WorkerLogout = ({ handleLogout }) => {
  return (
    <div className="wp-logout-wrap">
      <button className="wp-logout-btn" onClick={handleLogout}>
        <LogOut size={17} /> Log Out
      </button>
    </div>
  );
};

export default WorkerLogout;